import useMixedItemDist from "@hooks/useMixedItemDist";

const useItemsCount = () => {
	const { data } = useMixedItemDist();

	const isFetchingItemsCount = !data;

	let numPracticeTests = 0;
	let numQuiz = 0;

	if (data) {
		numPracticeTests = data.exams?.length
			? data.exams?.filter((exam) => {
					const isOlx =
						exam.subType === "PRACTICE_TEST" && exam.title.includes("OLX");
					return isOlx ? exam.hasAccess : exam.subType === "PRACTICE_TEST";
				})?.length
			: 0;

		numQuiz = data.exams?.length
			? data.exams?.filter(
					(exam) => exam.subType === "DIAGNOSTIC" && exam.numItems,
				)?.length
			: 0;
	}

	return {
		numPracticeTests,
		numQuiz,
		isFetchingItemsCount,
	};
};

export default useItemsCount;
